import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-3232f2ca"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "footer-flex pa-4" }
const _hoisted_2 = { class: "footer-block" }
const _hoisted_3 = { class: "bot-name" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "links-flex" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = ["href"]
const _hoisted_8 = { class: "footer-block" }
const _hoisted_9 = { class: "footer-bottom" }
const _hoisted_10 = { class: "ma-2" }

import vuetify from "@/plugins/vuetify";
import UFOLogo from "@/assets/logo-v2-dark.png";
import {ref} from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'Footer',
  setup(__props) {

const year = new Date().getFullYear();
const dark = ref(localStorage.getItem('theme') !== 'light')

function updateTheme() {
  let theme = dark.value ? 'dark' : 'light';
  localStorage.setItem('theme', theme);
  vuetify.theme.global.name.value = theme;
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_footer = _resolveComponent("v-footer")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_footer, {
      class: "footer",
      color: "footer"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("img", {
                src: _unref(UFOLogo),
                alt: "UFO Logo",
                class: "main-icon"
              }, null, 8, _hoisted_4),
              _createTextVNode("UFO ")
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (i) => {
              return _createElementVNode("div", {
                key: i,
                class: "footer-block"
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$tm('Footer.links'), (link) => {
                  return (_openBlock(), _createElementBlock("div", null, [
                    (link.block === i)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_6, [
                          (link.blank)
                            ? (_openBlock(), _createElementBlock("a", {
                                key: 0,
                                class: "footer-link",
                                target: "_blank",
                                href: _ctx.$rt(link.path)
                              }, _toDisplayString(_ctx.$rt(link.name)), 9, _hoisted_7))
                            : (_openBlock(), _createBlock(_component_router_link, {
                                key: 1,
                                class: "footer-link",
                                to: _ctx.$rt(link.path)
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$rt(link.name)), 1)
                                ]),
                                _: 2
                              }, 1032, ["to"]))
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                }), 256))
              ])
            }), 64))
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_v_switch, {
              modelValue: dark.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((dark).value = $event)),
              color: "primary",
              label: _ctx.$t('Footer.darkTheme'),
              onChange: updateTheme,
              "hide-details": ""
            }, null, 8, ["modelValue", "label"])
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_v_divider),
          _createElementVNode("div", _hoisted_10, "Smoky © " + _toDisplayString(_unref(year)) + " | " + _toDisplayString(_ctx.$t("Footer.rights")), 1)
        ])
      ]),
      _: 1
    })
  ]))
}
}

})